































import {
  Vue, Component, Prop, Watch, Mixins, Emit, PropSync,
} from 'vue-property-decorator'
import {
  contains, pickBy, values, map, clone, any,
} from 'ramda'
import firebase from 'firebase'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import { db } from '../../firebase/init'

@Component({
  components: {
  },
})
export default class AddCoupon extends Mixins(MainMixin) {
  $refs:any

  loading = false

  get couponCategories() {
    return this.$store.state.location.gData.couponCategories || []
  }

  get showDialog() {
    return this.activeCategory !== ''
  }

  async addCategory() {
    this.loading = true
    await db.collection('groups').doc(this.$store.getters.group).update({
      couponCategories: firebase.firestore.FieldValue.arrayUnion(this.newCategoryName),
    })
    this.loading = false
    this.$toast.success(`Category "${this.newCategoryName}" Added`)
    this.newCategoryName = ''
    return true
  }

  async removeCategory() {
    this.loading = true
    await db.collection('groups').doc(this.$store.getters.group).update({
      couponCategories: firebase.firestore.FieldValue.arrayRemove(this.activeCategory),
    })
    this.loading = false
    this.$toast.success(`Category "${this.activeCategory}" Removed`)
    this.activeCategory = ''
    return true
  }

  newCategoryName = ''

  activeCategory = ''
}

